import { Component, Input, Output, OnChanges } from 'angular-ts-decorators';
import { faRedo, faExclamation } from '@fortawesome/pro-solid-svg-icons';

/**
 * Component displays loading status
 *
 * # Attributes
 * * promise - initial promise
 * * retry - optional retry method that will re-create the promise
 *
 * # Example
 * <pre>
 *   <sw-loading promise="$ctrl.promiseValue" retry="callback()">
 *     content to be shown when promise is resolved
 *   </sw-loading>
 * </pre>
 */
@Component({
  selector: 'swLoading',
  transclude: true,
  template: require('./sw-loading.html').default,
})
export class SwLoadingComponent implements OnChanges {
  @Input() promise: ng.IPromise<any>;
  @Input('@retry') retryAttr: any;
  @Output() retry: () => any;

  faRedo = faRedo;
  faExclamation = faExclamation;
  state: string;
  error: string;

  constructor(private $log: ng.ILogService) {
    'ngInject';
  }

  ngOnChanges(changes) {
    if (changes && changes.promise && changes.promise.currentValue) {
      this.state = 'pending';
      this.error = undefined;

      this.promise
        .then(() => (this.state = 'resolved'))
        .catch((error) => {
          this.state = 'rejected';

          this.$log.error('error in <sw-loading>', error);

          if (angular.isString(error)) {
            this.error = error;
          }
        });
    }
  }
}
